import React from 'react';

import Container from '../Container';
import FooterGrid from './FooterGrid';
import FooterBottom from './FooterBottom';
import NewsLatter from './NewsLatter';

const Footer = () => {
    const footerLinkData = [
        {
            id:"1",
            title:"Why Datcom",
            link:"#",
            target:"_self"
        },
        {
            id:"2",
            title:"About Us",
            link:"#",
            target:"_self"
        },
        {
            id:"3",
            title:"Carrers",
            link:"#",
            target:"_self"
        },
        {
            id:"4",
            title:"Case Studies",
            link:"#",
            target:"_self"
        },
        {
            id:"5",
            title:"Blog",
            link:"#",
            target:"_self"
        }
    ];
    return (
        <>
            <NewsLatter />
            <footer className='py-5'>
                <Container>
                    <div className='row'>
                        <FooterGrid 
                            heading="Our Solutions"
                            links={footerLinkData}
                        />

                        <FooterGrid 
                            heading="Our Company"
                            links={footerLinkData}
                        />

                        <FooterGrid 
                            heading="Products and Platforms"
                            links={footerLinkData}
                        />

                        <FooterGrid 
                            heading="Insights"
                            links={footerLinkData}
                        />
                    </div>                           
                </Container>
            </footer>

            <div className='bg-black footer-bottom d-flex align-items-center py-4 py-lg-0'>
                <FooterBottom />
            </div>
        </>
    );
};

export default Footer;